import React from 'react';
import classnames from 'classnames';

import { LazyPicture } from '../../hooks/useLazyLoad';
import { contact } from '../../../../pwa/src/config';

import classes from './FooterCta.scss';

type FooterCtaProps = Record<string, unknown>;

export const FooterLogo: React.FC<FooterCtaProps> = ({ theme }) => (
    <LazyPicture
        data-alt={contact.name}
        className={classnames(classes.footerCtaLogo, {
            [classes.black]: theme === 'black',
            [classes.white]: theme === 'white',
        })}
    >
        <source srcSet={require(`../../../static/img/logo-header-desktop-${theme}-version.svg`)} />
    </LazyPicture>
);
